import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled, { css } from 'styled-components';

const Container = styled.div`
  width: 200px;
  height: 100%;
  gap: 16px;
  padding: 12px 0px;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 1;

  @media (max-width: 480px) {
    width: 100%;
    height: auto;
    padding: 0px;
    overflow-x: auto;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  display: flex;

  @media (max-width: 480px) {
    flex-direction: row;
    gap: 0px;
    width: max-content;
  }
`;

const MenuItem = styled.div<{ isActived?: boolean }>`
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: -0.4px;
  color: #939090;
  margin-bottom: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;

  :hover {
    color: #ffffff;

    a {
      color: #ffffff;
    }

    svg {
      fill: #ffffff;
    }
  }

  a {
    color: #939090;
    text-decoration: none;
  }

  svg {
    fill: #939090;
  }

  ${({ isActived }) =>
    isActived &&
    css`
      color: #ffffff;

      svg {
        fill: #ffffff;
      }
    `}

  @media (max-width: 480px) {
    margin-bottom: 0px;
    padding: 16px;
    border-bottom: 4px solid transparent;

    :hover {
      border-bottom: 4px solid var(--green-principal);
    }

    ${({ isActived }) =>
      isActived &&
      css`
        border-bottom: 4px solid var(--green-principal);
      `}
  }
`;

export type Props = {
  menuItems?: {
    label: string;
    icon: React.ReactNode;
    path: string;
    isExactPath?: boolean;
    onClick?: () => void;
  }[];
};

export const SideMenu: React.FC<Props> = (props) => {
  const location = useLocation();

  const isExactPath = (path: string) => {
    return location.pathname === path;
  };

  const containsPath = (path: string) => {
    return location.pathname.includes(path);
  };

  return (
    <Container>
      <Content>
        {props.menuItems?.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            onClick={(e) => {
              if (item.onClick) {
                e.preventDefault();
                item.onClick();
              }
            }}
          >
            <MenuItem
              isActived={item.isExactPath ? isExactPath(item.path) : containsPath(item.path)}
            >
              <div>{item.icon}</div>
              {item.label}
            </MenuItem>
          </Link>
        ))}
      </Content>
    </Container>
  );
};
